import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

import { CoreConfigService } from '../../../services/config/core-config.service';
import { OfficeSwitcherService } from '../../../services/service/office-switcher.service';
import { AppSwitcherService } from '../../../services/service/app-switcher.service';

@Component({
    selector: 'zx-office-selector-content',
    templateUrl: './office-selector-content.component.html',
    styleUrls: ['./office-selector-content.component.css'],
    outputs: ['change']
})
export class OfficeSelectorContentComponent implements OnInit, OnDestroy{

    
    @Output() changeOffice = new EventEmitter<any>();

	constructor(
		private officeSwitcher: OfficeSwitcherService,
	) {}

	ngOnInit(){ }
	ngOnDestroy(){ }
	
	get communityGroups() : any[] {
		return this.officeSwitcher.currentCommunityGroups;
	}
	get currentOffice(): any{
		return this.officeSwitcher.currentOffice;
	}
	get currentOfficeLevel(): string{
		return this.officeSwitcher.currentOfficeLevel;
	}
	get currentOfficeLevelText(): string{
		return this.officeSwitcher.currentOfficeLevelText;
	}

	get isNonOfficeLevel():boolean{
		return this.currentOfficeLevel==null;
	}

	parseSelectorTitle(): string{
        const text = this.officeSwitcher.currentOfficeLevelText;
        return "切换" + (text||"切换工作区");
	}
	parseOfficeIcon(officeNode: any): string{
		return this.officeSwitcher.parseOfficeIcon(officeNode);
	}

	onClickOfficeNode(office: any){
		this.officeSwitcher.tryLoadChildren(office);
	}

	onSearchCommunity(searchText, parentOffice){
		parentOffice.__searchText = searchText;
	}
	getSearchedCommunities(parentOffice:any){
		const searchText = parentOffice.__searchText;
		if(searchText){
			return parentOffice.communities.filter(item=>item.name.indexOf(searchText)!=-1);
		}
		return parentOffice.communities;
	}
	changeCurrentOffice(office: any){
        this.changeOffice.emit(office);
	}
}